export default __webpack_public_path__ + "static/media/pic1.3e1b1ebc.jpg";